
export const ValidationMessages = (props) => {
	return <div>
		<h3>{props.header}</h3>
		{props.messages.map((message, messageIndex) => <div key={`msg-${messageIndex}`} dangerouslySetInnerHTML={{ __html: message }} />)}
	</div>;
};